import { createBrowserRouter } from "react-router-dom";

import { AtiraRouteNotLoggedIn } from "../AtiraRouteNotLoggedIn";
import { Layout } from "../Layout";
import Login from "../../Login";
import { AtiraRoute } from "../AtiraRoute";
import { Home } from "../../Home";

const router = createBrowserRouter([
  {
    element: <Layout />,
    errorElement: <div>error</div>,
    children: [
      {
        path: "/login",
        element: <AtiraRouteNotLoggedIn component={<Login />} />,
      },
      {
        path: "/home",
        element: <AtiraRoute component={<Home />} />,
      },
      {
        path: "/",
        element: <AtiraRouteNotLoggedIn component={<Login />} />,
      },
    ],
  },
  { path: "*", element: <AtiraRoute redirect="/" /> },
]);

export default router;
